import Swal from "sweetalert2";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastError = err => {
        const errorMsg = err.response?.data?.error;
        let message;

        if (errorMsg) {
                if (i18n.exists(`backendErrors.${errorMsg}`)) {
                        message = i18n.t(`backendErrors.${errorMsg}`);
                } else {
                        message = errorMsg;
                }
        } else if (isString(err)) {
                message = err;
        } else {
                message = "An error occurred!";
        }

        Swal.fire({
                icon: "error",
                title: message,
                position: "center",
                allowOutsideClick: true,
        });
};

export default toastError;
